module.exports = __webpack_public_path__ + "static/img/myrianne.9a02ba8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff/myrianne.jpg
// module id = 210
// module chunks = 1